import { HierarchyQueryParams } from "functions/api/hierarchy/HierarchyQueryParams";
import { IRequestStatus } from "functions/api/interface";
import { createContext } from "react";
import { IHierarchyBrowserAction, IHierarchyBrowserContext } from "./interface";

export interface IHierarchyBrowserContextProps {
  state: IHierarchyBrowserContext;
  dispatch: React.Dispatch<IHierarchyBrowserAction>;
  loadCurrent: IRequestStatus<HierarchyQueryParams>;
  arRequest: IRequestStatus<string>;
}

/**
 * Context for the hierarchy browser.
 * Provides state, dispatch and request status helpers used by the hierarchy browser components.
 */
export const HierarchyBrowserContext = createContext<IHierarchyBrowserContextProps | null>(null);
